/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiUserBasicDetailsWithRoles,
    InternalApiUserBasicDetailsWithRolesFromJSON,
    InternalApiUserBasicDetailsWithRolesToJSON,
} from '../models';

/**
 * 
 */
export class UserBasicInternalApi extends runtime.BaseAPI {

    /**
     * Fetches all users basic details with roles
     */
    async findAllUsersBasicWithRolesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiUserBasicDetailsWithRoles>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/users-basic`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiUserBasicDetailsWithRolesFromJSON));
    }

    /**
     * Fetches all users basic details with roles
     */
    async findAllUsersBasicWithRoles(initOverrides?: RequestInit): Promise<Array<InternalApiUserBasicDetailsWithRoles>> {
        const response = await this.findAllUsersBasicWithRolesRaw(initOverrides);
        return await response.value();
    }

}
